import React from "react";
import { Helpers } from "../helpers/helpers";
import { IinitialState, ISelectedFilters, IVertexSearchPageAppProps, SearchContext } from "../models/vertex-search-page-models";
import { VertexSearchProvider } from "../reducers/vertex-search-page-provider";
import { SearchHeading } from "./search-heading";
import { SearchListing } from "./search-listing";

const VertexSearchPageApp = ({ epiProps, showHealthyChildrenBranding, healthyChildrenUrl, googleVertexCommerceVisitorId, disableGenerativeAIOverview, disableGenerativeAIOverviewAllAAPContext, disableGenerativeAIOverviewHealthyChildrenContext, generativeAIOverviewForceEnglishLanguage, recaptchaV3SiteKey }: IVertexSearchPageAppProps) => {

    const params = new URLSearchParams(window.location.search);
    const initialSearchQuery = params.get('k');
    const initialSearchContext = params.get('context');

    let initialSelectedShopFilters: ISelectedFilters = {};
    let selectedSelectedShopFiltersString: string = "";
    if (initialSearchContext == SearchContext.ShopAAP) {
        const initialShopFiltersQueryString = params.get('facets');
        if (initialShopFiltersQueryString && initialShopFiltersQueryString.length > 0) {
            initialSelectedShopFilters = Helpers.parseFacetsQueryString(initialShopFiltersQueryString);
            selectedSelectedShopFiltersString = Helpers.formatFiltersForGoogleVertexAPI(initialSelectedShopFilters);
        }
    }

    const initialState: IinitialState = {
        epiProps: epiProps,
        showHealthyChildrenBranding: showHealthyChildrenBranding,
        currentSearchContext: initialSearchContext ? initialSearchContext : SearchContext.AllAAP,
        searchResultsContainer: null,
        currentSearchQuery: initialSearchQuery ? initialSearchQuery : "",
        healthyChildrenUrl: healthyChildrenUrl,
        googleVertexCommerceVisitorId: googleVertexCommerceVisitorId,
        disableGenerativeAIOverview: disableGenerativeAIOverview,
        disableGenerativeAIOverviewAllAAPContext: disableGenerativeAIOverviewAllAAPContext,
        disableGenerativeAIOverviewHealthyChildrenContext: disableGenerativeAIOverviewHealthyChildrenContext,
        generativeAIOverviewForceEnglishLanguage: generativeAIOverviewForceEnglishLanguage,
        recaptchaV3SiteKey: recaptchaV3SiteKey,
        selectedShopFilters: initialSelectedShopFilters,
        selectedShopFiltersString: selectedSelectedShopFiltersString,
        facetsShowMoreState: {},
        facetsAccordionClosedState: {}
    };

    return (
        <VertexSearchProvider initialState={initialState}>
            <div className='vertex-search-page'>
                <SearchHeading />
                <SearchListing />
            </div>
        </VertexSearchProvider>
    )
}

export default VertexSearchPageApp